import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome back, ${user.name}!`);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="relative min-h-screen flex items-center justify-center pt-16 px-4">
      <div className="noise-overlay" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,179,1,0.06),transparent_55%)]" />
      <div className="relative w-full max-w-md rounded-2xl bg-[#0d0d0d] border border-white/10 p-8 fade-up" data-testid="login-card">
        <img src={LOGO_URL} alt="EBN" className="h-12 w-auto mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-center">Welcome Back</h1>
        <p className="mt-1 text-sm text-zinc-500 text-center">Log in to your EBN account</p>
        <form onSubmit={submit} className="mt-7 space-y-4 text-left">
          <input
            data-testid="login-email-input"
            type="email"
            placeholder="Email address"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-4 py-3 text-sm placeholder:text-zinc-600 focus:outline-none focus:border-[#F5B301]/50"
          />
          <input
            data-testid="login-password-input"
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-4 py-3 text-sm placeholder:text-zinc-600 focus:outline-none focus:border-[#F5B301]/50"
          />
          {error && <p data-testid="login-error" className="text-xs text-red-400">{error}</p>}
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-full bg-[#F5B301] text-black text-sm font-bold hover:bg-[#D99E01] transition-colors disabled:opacity-60"
          >
            {loading ? "Logging in…" : "Login"}
          </button>
        </form>
        <p className="mt-6 text-xs text-zinc-500 text-center">
          New to EBN?{" "}
          <Link to="/signup" data-testid="login-to-signup-link" className="text-[#F5B301] font-semibold hover:underline">Create an account</Link>
        </p>
      </div>
    </main>
  );
}
